
import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { ShrineOffering } from '@/hooks/use-shrine';

interface RecentContributionsProps {
  offerings: ShrineOffering[];
}

const RecentContributions: React.FC<RecentContributionsProps> = ({ offerings }) => {
  return (
    <div className="backdrop-blur-md bg-black/20 rounded-lg p-4 max-h-[300px] overflow-y-auto border border-cyan-600/30">
      <h3 className="text-cyan-300 text-xl font-bold mb-4 uppercase tracking-wider">Recent Offerings</h3>
      {offerings.length === 0 ? (
        <p className="text-cyan-500 text-center">No recent offerings</p>
      ) : (
        <ul className="space-y-2">
          {offerings.map((offering) => (
            <li 
              key={offering.id} 
              className="flex items-center justify-between backdrop-blur-sm bg-black/20 p-2 rounded-md border border-cyan-600/20 hover:bg-black/30 transition-colors"
            >
              <div className="flex items-center space-x-3">
                <Avatar className="w-8 h-8 border border-cyan-600/50">
                  <AvatarImage 
                    src={offering.profile_image_url || ''} 
                    alt={offering.username}
                  />
                  <AvatarFallback className="bg-cyan-900/50 text-cyan-300">
                    {offering.username[0]}
                  </AvatarFallback>
                </Avatar>
                <span className="text-cyan-300 text-sm">{offering.username}</span>
              </div>
              <span className="text-cyan-400 font-bold text-sm">
                {offering.amount} ♔
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default RecentContributions;
